export const firebaseConfig = {
  apiKey: "AIzaSyCqMc9iu7lf7NVUbSdbdVjM0JQ2palsSQ8",
  authDomain: "tradelah-7cc82.firebaseapp.com",
  databaseURL: "https://tradelah-7cc82.firebaseio.com",
  projectId: "tradelah-7cc82",
  storageBucket: "tradelah-7cc82.appspot.com",
  messagingSenderId: "439769568515",
  appId: "1:439769568515:web:462ac373ccd28b7cc38536",
  measurementId: "G-72D56JY7VE"
};
